import { inject, Injectable } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { BehaviorSubject } from 'rxjs'

/**
 * Service to handle changing the page title for the various components.
 */
@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private readonly title = inject(Title)
  public updateTitle = new BehaviorSubject<void>(undefined)

  setPageTitle (value: string) {
    if (value) {
      this.title.setTitle(value)
    }
  }

  getUpdateTitle () {
    return this.updateTitle.asObservable()
  }
}
